import { useEffect, useState } from "react";
import { api, parseApiError } from "@/lib/api";
import { PageHeader } from "./AdminLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function HRMDailyWork() {
  const [branches, setBranches] = useState([]);
  const [rules, setRules] = useState([]);
  const [form, setForm] = useState({ work_date: new Date().toISOString().slice(0, 10), headcount_signal: 0 });
  const [rule, setRule] = useState({ condition_name: "low_traffic", override_json: "{\"add_tasks\":[]}", priority: 100 });
  const [result, setResult] = useState(null);

  const load = async () => {
    const [branchRes, ruleRes] = await Promise.all([api.get("/branches"), api.get("/hrm/override-rules")]);
    setBranches(branchRes.data); setRules(ruleRes.data);
  };
  useEffect(() => { load().catch(() => toast.error("Không tải được daily work")); }, []);

  const generate = async () => {
    try {
      const res = await api.post("/hrm/daily-work/generate", { ...form, headcount_signal: Number(form.headcount_signal), branch_id: form.branch_id || null });
      setResult(res.data); toast.success("Đã tạo công việc hằng ngày");
    } catch (e) { toast.error(parseApiError(e, "Lỗi").message); }
  };
  const saveRule = async () => {
    try {
      await api.post("/hrm/override-rules", { ...rule, branch_id: rule.branch_id || form.branch_id, override_json: JSON.parse(rule.override_json || "{}") });
      setRule({ condition_name: "low_traffic", override_json: "{\"add_tasks\":[]}", priority: 100 }); await load(); toast.success("Đã tạo override");
    } catch (e) { toast.error(parseApiError(e, "Lỗi JSON").message); }
  };

  return (
    <div data-testid="page-hrm-daily-work">
      <PageHeader kicker="HRM" title="Công việc hằng ngày" breadcrumb={["HRM", "Daily work"]} />
      <div className="p-6 lg:p-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
        <section className="space-y-3">
          <h3 className="font-semibold">Tạo task theo ca</h3>
          <select className="w-full h-9 border border-stone-200 rounded-sm px-2" value={form.branch_id || ""} onChange={(e) => setForm({ ...form, branch_id: e.target.value })} data-testid="hrm-dw-branch">
            <option value="">Chọn cơ sở</option>
            {branches.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
          </select>
          <Input type="date" value={form.work_date} onChange={(e) => setForm({ ...form, work_date: e.target.value })} data-testid="hrm-dw-date" />
          <select className="w-full h-9 border border-stone-200 rounded-sm px-2" value={form.headcount_signal} onChange={(e) => setForm({ ...form, headcount_signal: e.target.value })} data-testid="hrm-dw-headcount">
            <option value={-1}>Khách ít</option><option value={0}>Bình thường</option><option value={1}>Khách đông</option>
          </select>
          <Button onClick={generate} className="rounded-sm bg-emerald-800 hover:bg-emerald-900" data-testid="hrm-dw-generate">Generate</Button>
          {result && <pre className="text-xs bg-stone-950 text-stone-100 p-3 rounded-sm overflow-auto">{JSON.stringify(result, null, 2)}</pre>}
        </section>
        <section className="space-y-3">
          <h3 className="font-semibold">Quy tắc override</h3>
          <Input placeholder="Điều kiện" value={rule.condition_name} onChange={(e) => setRule({ ...rule, condition_name: e.target.value })} />
          <Textarea rows={6} value={rule.override_json} onChange={(e) => setRule({ ...rule, override_json: e.target.value })} />
          <Button onClick={saveRule} className="rounded-sm bg-emerald-800 hover:bg-emerald-900">Lưu override</Button>
          <div className="bg-white border border-stone-200 rounded-sm divide-y">
            {rules.map((item) => <div key={item.id} className="p-3 text-sm" data-testid={`hrm-dw-rule-${item.id}`}><b>{item.condition_name}</b><div className="text-xs text-stone-500">{item.active ? "Đang bật" : "Tắt"}</div></div>)}
          </div>
        </section>
      </div>
    </div>
  );
}
